module.exports = __webpack_public_path__ + "img/details-mail.55aedc42.svg";